// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3uu5v","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3mGg1"};